import classNames from "classnames";
import React, { useCallback, useImperativeHandle } from "react";
import { useDropzone } from "react-dropzone";
import styles from "./FileSelector.scss";
import { acceptToTypeMapping } from "./helper";

export const FileSelector = React.forwardRef(function FileSelector(
    { visible = false, onSelect, onClose, multiple = false, accept },
    ref
) {
    const onDrop = useCallback(
        (acceptedFiles) => {
            onSelect && onSelect(acceptedFiles);
        },
        [onSelect]
    );

    const { getRootProps, getInputProps, open } = useDropzone({
        onDrop,
        onFileDialogCancel: onClose,
        noClick: true,
        noKeyboard: true,
        multiple,
        accept: acceptToTypeMapping(accept)
    });

    // Expose `open` to parent via ref
    useImperativeHandle(ref, () => ({
        open: () => open()
    }));

    return (
        <div
            {...getRootProps()}
            className={classNames(styles.base, {
                [styles.visible]: visible
            })}
        >
            <input {...getInputProps()} />
        </div>
    );
});
